import React, { useState } from 'react';
import { money, exampleText } from './format';

const STATUS_LABEL = { pass: 'OK', warn: 'Review', fail: 'Action needed', na: 'Not set up' };
const STATUS_ORDER = { fail: 0, warn: 1, pass: 2, na: 3 };
const SEVERITY_ORDER = { critical: 0, high: 1, medium: 2, low: 3 };
const GROUPS = ['Bank', 'Sales', 'Purchases', 'VAT', 'Coding', 'Contacts', 'Balance sheet'];

function Finding({ f }) {
  const [open, setOpen] = useState(false);
  const hasExamples = f.examples && f.examples.length > 0 && f.status !== 'pass';
  return (
    <div className={`hc-finding hc-${f.status}`}>
      <div className="hc-finding-head">
        <span className={`hc-pill hc-pill-${f.status}`}>{STATUS_LABEL[f.status] || f.status}</span>
        <span className="hc-finding-title">{f.title}</span>
        <span className="hc-severity">{f.severity}</span>
      </div>
      <div className="hc-summary">
        {f.summary}
        {f.value && f.status !== 'pass' ? <> ({money(f.value)})</> : null}
      </div>
      {(hasExamples || f.why) && (
        <button className="hc-toggle" onClick={() => setOpen(o => !o)}>
          {open ? 'Hide details' : hasExamples ? `Why it matters · ${f.examples.length} example${f.examples.length === 1 ? '' : 's'}` : 'Why it matters'}
        </button>
      )}
      {open && (
        <>
          {f.why && <p className="hc-why">{f.why}</p>}
          {hasExamples && (
            <ul className="hc-examples">
              {f.examples.map((ex, i) => <li key={i}>{exampleText(ex)}</li>)}
            </ul>
          )}
        </>
      )}
    </div>
  );
}

export default function FindingsView({ findings }) {
  const [filter, setFilter] = useState('issues');
  const shown = findings.filter(f => filter === 'all' || f.status === 'fail' || f.status === 'warn');
  const sorted = (list) => list.slice().sort((a, b) =>
    (STATUS_ORDER[a.status] - STATUS_ORDER[b.status]) || (SEVERITY_ORDER[a.severity] - SEVERITY_ORDER[b.severity]));
  const groups = GROUPS.map(g => [g, sorted(shown.filter(f => f.group === g))]).filter(([, l]) => l.length);

  return (
    <>
      <div className="filter-chips">
        <button className={`chip ${filter === 'issues' ? 'active' : ''}`} onClick={() => setFilter('issues')}>Issues only</button>
        <button className={`chip ${filter === 'all' ? 'active' : ''}`} onClick={() => setFilter('all')}>All {findings.length} checks</button>
      </div>
      {groups.length === 0 && <div className="empty-tab">No issues found.</div>}
      {groups.map(([g, list]) => (
        <div key={g} className="hc-group">
          <h3 className="hc-group-title">{g}</h3>
          <div className="hc-list">{list.map(f => <Finding key={f.code} f={f} />)}</div>
        </div>
      ))}
    </>
  );
}
